// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HeaderPage — announcement bar, sticky header, mobile drawer
   Prefix: upskld_heade_pg_ · no :root variables · no green
   NOTE: no transform / filter / backdrop-filter on the header itself,
   otherwise the fixed mobile drawer inside it would break.
   ============================================================ */

.upskld_heade_pg_header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  background-color: #ffffff;
  font-family: "Sora", sans-serif;
  box-shadow: 0 4px 18px rgba(76, 29, 149, 0.06);
  transition: box-shadow 0.35s ease;
}

.upskld_heade_pg_header *,
.upskld_heade_pg_header *::before,
.upskld_heade_pg_header *::after {
  box-sizing: border-box;
}

.upskld_heade_pg_header_scrolled {
  box-shadow: 0 10px 30px rgba(76, 29, 149, 0.14);
}

/* ============================================================
   Announcement bar
   ============================================================ */

.upskld_heade_pg_announce {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  background: linear-gradient(90deg, #4c1d95 0%, #5b21b6 50%, #4c1d95 100%);
  font-family: "Sora", sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}

.upskld_heade_pg_announce_text {
  display: inline-block;
  animation: upskld_heade_pg_announce_in 0.5s ease both;
}

@keyframes upskld_heade_pg_announce_in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================================
   Main row: logo | nav (truly centred) | action
   ============================================================ */

.upskld_heade_pg_container {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  column-gap: 24px;
  width: 100%;
  max-width: 1240px;
  min-height: 68px;
  margin: 0 auto;
  padding: 10px 24px;
}

/* ---------- Logo (fixed height, never overflows the header) ---------- */

.upskld_heade_pg_logo {
  display: inline-flex;
  align-items: center;
  justify-self: start;
  height: 48px;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.upskld_heade_pg_logo_img {
  display: block;
  width: auto;
  height: 100%;
  max-width: 190px;
  object-fit: contain;
  object-position: left center;
  transition: transform 0.35s ease;
}

.upskld_heade_pg_logo:hover .upskld_heade_pg_logo_img {
  transform: scale(1.05);
}

/* ---------- Desktop nav ---------- */

.upskld_heade_pg_nav_desktop {
  display: flex;
  justify-content: center;
}

.upskld_heade_pg_nav_list {
  display: flex;
  align-items: center;
  gap: 36px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.upskld_heade_pg_nav_item {
  display: flex;
}

.upskld_heade_pg_nav_link {
  position: relative;
  padding: 8px 0;
  border: 0;
  background: none;
  font-family: "Sora", sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #5f5f73;
  cursor: pointer;
  transition: color 0.25s ease;
}

.upskld_heade_pg_nav_link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #5b21b6 0%, #e0a83d 100%);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.upskld_heade_pg_nav_link:hover {
  color: #12112a;
}

.upskld_heade_pg_nav_link:hover::after {
  transform: scaleX(0.55);
}

.upskld_heade_pg_nav_link_active {
  font-weight: 700;
  color: #12112a;
}

.upskld_heade_pg_nav_link_active::after,
.upskld_heade_pg_nav_link_active:hover::after {
  transform: scaleX(1);
}

/* ---------- Desktop action ---------- */

.upskld_heade_pg_actions_desktop {
  display: flex;
  align-items: center;
  justify-self: end;
}

.upskld_heade_pg_book_btn {
  position: relative;
  padding: 12px 24px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(100deg, #5b21b6 0%, #6d28d9 100%);
  box-shadow:
    0 12px 26px rgba(91, 33, 182, 0.4),
    0 3px 8px rgba(91, 33, 182, 0.25);
  font-family: "Sora", sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* light sweep across the button on hover */
.upskld_heade_pg_book_btn::after {
  content: "";
  position: absolute;
  top: 0;
  left: -70%;
  width: 50%;
  height: 100%;
  background: linear-gradient(100deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.upskld_heade_pg_book_btn:hover {
  transform: translateY(-2px);
  box-shadow:
    0 18px 34px rgba(91, 33, 182, 0.5),
    0 4px 10px rgba(91, 33, 182, 0.3);
}

.upskld_heade_pg_book_btn:hover::after {
  left: 130%;
}

.upskld_heade_pg_book_btn:active {
  transform: translateY(0) scale(0.97);
  box-shadow: 0 8px 18px rgba(91, 33, 182, 0.4);
}

/* ============================================================
   Mobile menu icon
   ============================================================ */

.upskld_heade_pg_menu_icon {
  position: relative;
  z-index: 1001;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: #f5f1ff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.upskld_heade_pg_bar {
  width: 20px;
  height: 2px;
  border-radius: 2px;
  background-color: #4c1d95;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(2) {
  opacity: 0;
}

.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ============================================================
   Mobile overlay + drawer
   ============================================================ */

.upskld_heade_pg_mobile_overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  display: none;
  width: 100%;
  height: 100%;
  background: rgba(18, 17, 42, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.35s ease, visibility 0.35s ease;
}

.upskld_heade_pg_mobile_overlay_open {
  opacity: 1;
  visibility: visible;
}

.upskld_heade_pg_mobile_menu {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  display: none;
  flex-direction: column;
  width: 300px;
  max-width: 84%;
  height: 100%;
  padding: 112px 24px 28px;
  background-color: #ffffff;
  box-shadow: -10px 0 40px rgba(18, 17, 42, 0.18);
  transform: translateX(105%);
  visibility: hidden;
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1), visibility 0.45s;
}

.upskld_heade_pg_mobile_menu_open {
  transform: translateX(0);
  visibility: visible;
}

.upskld_heade_pg_mobile_nav_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* drawer items slide in one after another */
.upskld_heade_pg_mobile_nav_item,
.upskld_heade_pg_mobile_actions {
  opacity: 0;
  transform: translateX(24px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.upskld_heade_pg_mobile_menu_open .upskld_heade_pg_mobile_nav_item,
.upskld_heade_pg_mobile_menu_open .upskld_heade_pg_mobile_actions {
  opacity: 1;
  transform: none;
  transition:
    opacity 0.5s ease calc(var(--n, 0) * 80ms + 200ms),
    transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--n, 0) * 80ms + 200ms);
}

.upskld_heade_pg_mobile_nav_link {
  width: 100%;
  padding: 13px 14px;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 0 8px 8px 0;
  background: none;
  font-family: "Sora", sans-serif;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  color: #5f5f73;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.upskld_heade_pg_mobile_nav_link_active {
  border-left-color: #5b21b6;
  background-color: #f5f1ff;
  color: #4c1d95;
}

.upskld_heade_pg_mobile_actions {
  margin-top: 26px;
  padding-top: 24px;
  border-top: 1px solid #ece7fa;
}

.upskld_heade_pg_mobile_book_btn {
  width: 100%;
  padding: 15px 20px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(100deg, #5b21b6 0%, #6d28d9 100%);
  box-shadow:
    0 12px 26px rgba(91, 33, 182, 0.4),
    0 3px 8px rgba(91, 33, 182, 0.25);
  font-family: "Sora", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.upskld_heade_pg_mobile_book_btn:active {
  transform: scale(0.97);
  box-shadow: 0 8px 18px rgba(91, 33, 182, 0.4);
}

/* ---------- Focus ---------- */

.upskld_heade_pg_nav_link:focus-visible,
.upskld_heade_pg_book_btn:focus-visible,
.upskld_heade_pg_mobile_nav_link:focus-visible,
.upskld_heade_pg_mobile_book_btn:focus-visible,
.upskld_heade_pg_menu_icon:focus-visible,
.upskld_heade_pg_announce:focus-visible,
.upskld_heade_pg_logo:focus-visible {
  outline: 2px solid #5b21b6;
  outline-offset: 3px;
  border-radius: 8px;
}

/* ============================================================
   Responsive
   ============================================================ */

@media (min-width: 600px) {
  .upskld_heade_pg_announce {
    font-size: 12px;
  }
}

@media (max-width: 1100px) {
  .upskld_heade_pg_container {
    padding: 10px 20px;
    column-gap: 16px;
  }

  .upskld_heade_pg_nav_list {
    gap: 24px;
  }
}

/* switch to hamburger + drawer */
@media (max-width: 860px) {
  .upskld_heade_pg_container {
    display: flex;
    justify-content: space-between;
    min-height: 62px;
    padding: 8px 16px;
  }

  .upskld_heade_pg_logo {
    height: 42px;
  }

  .upskld_heade_pg_logo_img {
    max-width: 160px;
  }

  .upskld_heade_pg_nav_desktop,
  .upskld_heade_pg_actions_desktop {
    display: none;
  }

  .upskld_heade_pg_menu_icon {
    display: flex;
  }

  .upskld_heade_pg_mobile_overlay,
  .upskld_heade_pg_mobile_menu {
    display: flex;
  }
}

@media (max-width: 360px) {
  .upskld_heade_pg_announce {
    padding: 7px 10px;
    font-size: 10px;
  }

  .upskld_heade_pg_container {
    padding: 8px 12px;
  }

  .upskld_heade_pg_logo {
    height: 38px;
  }

  .upskld_heade_pg_logo_img {
    max-width: 140px;
  }

  .upskld_heade_pg_mobile_menu {
    padding: 104px 18px 24px;
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .upskld_heade_pg_announce_text {
    animation: none;
  }

  .upskld_heade_pg_nav_link::after,
  .upskld_heade_pg_mobile_menu,
  .upskld_heade_pg_mobile_nav_item,
  .upskld_heade_pg_mobile_actions,
  .upskld_heade_pg_book_btn,
  .upskld_heade_pg_book_btn::after,
  .upskld_heade_pg_logo_img {
    transition: none !important;
  }

  .upskld_heade_pg_mobile_nav_item,
  .upskld_heade_pg_mobile_actions {
    opacity: 1;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/HeadFootPage/HeaderPage/HeaderPage.css"],"names":[],"mappings":"AAEA;;;;;iEAKiE;;AAEjE;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;iEAEiE;;AAEjE;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,yEAAyE;EACzE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0EAA0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,4DAA4D;EAC5D,oBAAoB;EACpB,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D;;qCAEmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,0HAA0H;EAC1H,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B;;qCAEmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,UAAU;EACV,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;;EAEE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf;;kFAEgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D;;qCAEmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,gCAAgC;;AAEhC;;;;;;;EAOE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,eAAe;EACjB;;EAEA;;;;;;;IAOE,2BAA2B;EAC7B;;EAEA;;IAEE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&display=swap\");\n\n/* ============================================================\n   HeaderPage — announcement bar, sticky header, mobile drawer\n   Prefix: upskld_heade_pg_ · no :root variables · no green\n   NOTE: no transform / filter / backdrop-filter on the header itself,\n   otherwise the fixed mobile drawer inside it would break.\n   ============================================================ */\n\n.upskld_heade_pg_header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n  background-color: #ffffff;\n  font-family: \"Sora\", sans-serif;\n  box-shadow: 0 4px 18px rgba(76, 29, 149, 0.06);\n  transition: box-shadow 0.35s ease;\n}\n\n.upskld_heade_pg_header *,\n.upskld_heade_pg_header *::before,\n.upskld_heade_pg_header *::after {\n  box-sizing: border-box;\n}\n\n.upskld_heade_pg_header_scrolled {\n  box-shadow: 0 10px 30px rgba(76, 29, 149, 0.14);\n}\n\n/* ============================================================\n   Announcement bar\n   ============================================================ */\n\n.upskld_heade_pg_announce {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  border: 0;\n  background: linear-gradient(90deg, #4c1d95 0%, #5b21b6 50%, #4c1d95 100%);\n  font-family: \"Sora\", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.upskld_heade_pg_announce_text {\n  display: inline-block;\n  animation: upskld_heade_pg_announce_in 0.5s ease both;\n}\n\n@keyframes upskld_heade_pg_announce_in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================================\n   Main row: logo | nav (truly centred) | action\n   ============================================================ */\n\n.upskld_heade_pg_container {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 24px;\n  width: 100%;\n  max-width: 1240px;\n  min-height: 68px;\n  margin: 0 auto;\n  padding: 10px 24px;\n}\n\n/* ---------- Logo (fixed height, never overflows the header) ---------- */\n\n.upskld_heade_pg_logo {\n  display: inline-flex;\n  align-items: center;\n  justify-self: start;\n  height: 48px;\n  max-width: 100%;\n  padding: 0;\n  border: 0;\n  background: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.upskld_heade_pg_logo_img {\n  display: block;\n  width: auto;\n  height: 100%;\n  max-width: 190px;\n  object-fit: contain;\n  object-position: left center;\n  transition: transform 0.35s ease;\n}\n\n.upskld_heade_pg_logo:hover .upskld_heade_pg_logo_img {\n  transform: scale(1.05);\n}\n\n/* ---------- Desktop nav ---------- */\n\n.upskld_heade_pg_nav_desktop {\n  display: flex;\n  justify-content: center;\n}\n\n.upskld_heade_pg_nav_list {\n  display: flex;\n  align-items: center;\n  gap: 36px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.upskld_heade_pg_nav_item {\n  display: flex;\n}\n\n.upskld_heade_pg_nav_link {\n  position: relative;\n  padding: 8px 0;\n  border: 0;\n  background: none;\n  font-family: \"Sora\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #5f5f73;\n  cursor: pointer;\n  transition: color 0.25s ease;\n}\n\n.upskld_heade_pg_nav_link::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 2px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, #5b21b6 0%, #e0a83d 100%);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.upskld_heade_pg_nav_link:hover {\n  color: #12112a;\n}\n\n.upskld_heade_pg_nav_link:hover::after {\n  transform: scaleX(0.55);\n}\n\n.upskld_heade_pg_nav_link_active {\n  font-weight: 700;\n  color: #12112a;\n}\n\n.upskld_heade_pg_nav_link_active::after,\n.upskld_heade_pg_nav_link_active:hover::after {\n  transform: scaleX(1);\n}\n\n/* ---------- Desktop action ---------- */\n\n.upskld_heade_pg_actions_desktop {\n  display: flex;\n  align-items: center;\n  justify-self: end;\n}\n\n.upskld_heade_pg_book_btn {\n  position: relative;\n  padding: 12px 24px;\n  border: 0;\n  border-radius: 10px;\n  background: linear-gradient(100deg, #5b21b6 0%, #6d28d9 100%);\n  box-shadow:\n    0 12px 26px rgba(91, 33, 182, 0.4),\n    0 3px 8px rgba(91, 33, 182, 0.25);\n  font-family: \"Sora\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: #ffffff;\n  cursor: pointer;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* light sweep across the button on hover */\n.upskld_heade_pg_book_btn::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -70%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(100deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.upskld_heade_pg_book_btn:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 18px 34px rgba(91, 33, 182, 0.5),\n    0 4px 10px rgba(91, 33, 182, 0.3);\n}\n\n.upskld_heade_pg_book_btn:hover::after {\n  left: 130%;\n}\n\n.upskld_heade_pg_book_btn:active {\n  transform: translateY(0) scale(0.97);\n  box-shadow: 0 8px 18px rgba(91, 33, 182, 0.4);\n}\n\n/* ============================================================\n   Mobile menu icon\n   ============================================================ */\n\n.upskld_heade_pg_menu_icon {\n  position: relative;\n  z-index: 1001;\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  width: 42px;\n  height: 42px;\n  flex-shrink: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: #f5f1ff;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.upskld_heade_pg_bar {\n  width: 20px;\n  height: 2px;\n  border-radius: 2px;\n  background-color: #4c1d95;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(2) {\n  opacity: 0;\n}\n\n.upskld_heade_pg_menu_icon_active .upskld_heade_pg_bar:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* ============================================================\n   Mobile overlay + drawer\n   ============================================================ */\n\n.upskld_heade_pg_mobile_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 998;\n  display: none;\n  width: 100%;\n  height: 100%;\n  background: rgba(18, 17, 42, 0.5);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.35s ease, visibility 0.35s ease;\n}\n\n.upskld_heade_pg_mobile_overlay_open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.upskld_heade_pg_mobile_menu {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 999;\n  display: none;\n  flex-direction: column;\n  width: 300px;\n  max-width: 84%;\n  height: 100%;\n  padding: 112px 24px 28px;\n  background-color: #ffffff;\n  box-shadow: -10px 0 40px rgba(18, 17, 42, 0.18);\n  transform: translateX(105%);\n  visibility: hidden;\n  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1), visibility 0.45s;\n}\n\n.upskld_heade_pg_mobile_menu_open {\n  transform: translateX(0);\n  visibility: visible;\n}\n\n.upskld_heade_pg_mobile_nav_list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* drawer items slide in one after another */\n.upskld_heade_pg_mobile_nav_item,\n.upskld_heade_pg_mobile_actions {\n  opacity: 0;\n  transform: translateX(24px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.upskld_heade_pg_mobile_menu_open .upskld_heade_pg_mobile_nav_item,\n.upskld_heade_pg_mobile_menu_open .upskld_heade_pg_mobile_actions {\n  opacity: 1;\n  transform: none;\n  transition:\n    opacity 0.5s ease calc(var(--n, 0) * 80ms + 200ms),\n    transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--n, 0) * 80ms + 200ms);\n}\n\n.upskld_heade_pg_mobile_nav_link {\n  width: 100%;\n  padding: 13px 14px;\n  border: 0;\n  border-left: 3px solid transparent;\n  border-radius: 0 8px 8px 0;\n  background: none;\n  font-family: \"Sora\", sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: left;\n  color: #5f5f73;\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.upskld_heade_pg_mobile_nav_link_active {\n  border-left-color: #5b21b6;\n  background-color: #f5f1ff;\n  color: #4c1d95;\n}\n\n.upskld_heade_pg_mobile_actions {\n  margin-top: 26px;\n  padding-top: 24px;\n  border-top: 1px solid #ece7fa;\n}\n\n.upskld_heade_pg_mobile_book_btn {\n  width: 100%;\n  padding: 15px 20px;\n  border: 0;\n  border-radius: 10px;\n  background: linear-gradient(100deg, #5b21b6 0%, #6d28d9 100%);\n  box-shadow:\n    0 12px 26px rgba(91, 33, 182, 0.4),\n    0 3px 8px rgba(91, 33, 182, 0.25);\n  font-family: \"Sora\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.upskld_heade_pg_mobile_book_btn:active {\n  transform: scale(0.97);\n  box-shadow: 0 8px 18px rgba(91, 33, 182, 0.4);\n}\n\n/* ---------- Focus ---------- */\n\n.upskld_heade_pg_nav_link:focus-visible,\n.upskld_heade_pg_book_btn:focus-visible,\n.upskld_heade_pg_mobile_nav_link:focus-visible,\n.upskld_heade_pg_mobile_book_btn:focus-visible,\n.upskld_heade_pg_menu_icon:focus-visible,\n.upskld_heade_pg_announce:focus-visible,\n.upskld_heade_pg_logo:focus-visible {\n  outline: 2px solid #5b21b6;\n  outline-offset: 3px;\n  border-radius: 8px;\n}\n\n/* ============================================================\n   Responsive\n   ============================================================ */\n\n@media (min-width: 600px) {\n  .upskld_heade_pg_announce {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .upskld_heade_pg_container {\n    padding: 10px 20px;\n    column-gap: 16px;\n  }\n\n  .upskld_heade_pg_nav_list {\n    gap: 24px;\n  }\n}\n\n/* switch to hamburger + drawer */\n@media (max-width: 860px) {\n  .upskld_heade_pg_container {\n    display: flex;\n    justify-content: space-between;\n    min-height: 62px;\n    padding: 8px 16px;\n  }\n\n  .upskld_heade_pg_logo {\n    height: 42px;\n  }\n\n  .upskld_heade_pg_logo_img {\n    max-width: 160px;\n  }\n\n  .upskld_heade_pg_nav_desktop,\n  .upskld_heade_pg_actions_desktop {\n    display: none;\n  }\n\n  .upskld_heade_pg_menu_icon {\n    display: flex;\n  }\n\n  .upskld_heade_pg_mobile_overlay,\n  .upskld_heade_pg_mobile_menu {\n    display: flex;\n  }\n}\n\n@media (max-width: 360px) {\n  .upskld_heade_pg_announce {\n    padding: 7px 10px;\n    font-size: 10px;\n  }\n\n  .upskld_heade_pg_container {\n    padding: 8px 12px;\n  }\n\n  .upskld_heade_pg_logo {\n    height: 38px;\n  }\n\n  .upskld_heade_pg_logo_img {\n    max-width: 140px;\n  }\n\n  .upskld_heade_pg_mobile_menu {\n    padding: 104px 18px 24px;\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .upskld_heade_pg_announce_text {\n    animation: none;\n  }\n\n  .upskld_heade_pg_nav_link::after,\n  .upskld_heade_pg_mobile_menu,\n  .upskld_heade_pg_mobile_nav_item,\n  .upskld_heade_pg_mobile_actions,\n  .upskld_heade_pg_book_btn,\n  .upskld_heade_pg_book_btn::after,\n  .upskld_heade_pg_logo_img {\n    transition: none !important;\n  }\n\n  .upskld_heade_pg_mobile_nav_item,\n  .upskld_heade_pg_mobile_actions {\n    opacity: 1;\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
